import { styled, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import HTMLRenderer from "react-html-renderer";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { SnackbarContext } from "../../../components/notification/snackbar.context";
import HorizontalDivider from "../../../components/utils/horizontal-divider.component";
import PaddedView from "../../../components/utils/padded-view.component";
import Spacer from "../../../components/utils/spacer.component";
import { getTerm } from "../../../services/term/term-slice.service";

const SectionText = styled(Typography)(({ theme }) => ({
  fontSize: theme.fonts.fontSizes.size18,
  fontWeight: "bold",
}));

function MerchantTermsScreen() {
  const dispatch = useDispatch();
  const createSnackBar = useContext(SnackbarContext);
  const { slug } = useParams(); // 👈 grabs the :slug from the URL
  const [termHtml, setTermHtml] = useState(null);

  useEffect(() => {
    dispatch(getTerm(slug)).then(({ meta, error, payload }) => {
      if (meta.requestStatus === "fulfilled") {
        if (payload.data.term) {
          setTermHtml(payload.data.term);
        } else {
          setTermHtml("<p>No terms provided by the merchant.</p>");
        }
      }

      if (meta.requestStatus === "rejected") {
        createSnackBar({
          message: error?.message || "Failed to fetch terms.",
          type: "error",
          open: true,
        });
      }
    });
  }, []);

  return (
    <PaddedView>
      <SectionText>Merchant Terms & Conditions</SectionText>
      <Spacer size="l" />
      <HorizontalDivider />
      <Spacer size="m" />
      {termHtml ? <HTMLRenderer html={termHtml} /> : <Typography>Loading...</Typography>}
    </PaddedView>
  );
}

export default MerchantTermsScreen;
